export type Day = 'MO' | 'TU' | 'WE' | 'TH' | 'FR' | 'SA' | 'SU';

const DAYS_MAP: Record<Day, number> = {
  MO: 6, // 1
  TU: 5, // 2
  WE: 4, // 4
  TH: 3, // 8
  FR: 2, // 16
  SA: 1, // 32
  SU: 0, // 64
};

export const scheduledBuildWeekdays: Day[] = Object.keys(DAYS_MAP) as Day[];

export const daysToNumeric = (days: Day[]) => {
  if (days.length === 0) {
    return 0;
  }
  const bitwiseArray = Array(7).fill('0');
  days.forEach((day: Day) => {
    const index = DAYS_MAP[day];
    bitwiseArray[index] = '1';
  });

  return parseInt(bitwiseArray.join(''), 2);
};

export const numericToWeekdayIndexes = (numeric: number) => {
  if (!numeric) {
    return undefined;
  }
  const bitwiseArray = numeric.toString(2).padStart(7, '0').split('').reverse();
  const indexes: number[] = [];
  bitwiseArray.forEach((n, index) => {
    if (n === '1') {
      indexes.push(index);
    }
  });

  return indexes;
};

export const numericToWeekdays = (numeric: number) => {
  const bitwiseArray = numeric.toString(2).padStart(7, '0').split('').reverse();
  const days: Day[] = [];
  bitwiseArray.forEach((n, index) => {
    if (n === '1') {
      days.push(scheduledBuildWeekdays[index]);
    }
  });

  return days;
};
